
class SystemApi {

    constructor(jsonApi) {
        this.jsonApi = jsonApi;
    }

    getConfig(successFunction, errorFunction = null) {
        const path = 'admin/config.php';
        this.jsonApi.get(path,
            (data) => {
                successFunction(data.data);
            },
            errorFunction);
    }

    errorReport(message, data) {
        this.sendReport('error', message, data);
    }

    successReport(message, data) {
        this.sendReport('success', message, data);
    }

    sendReport(type, message, data) {
        const path = 'admin/statusreport.php';
        const sendData = {
            type: type,
            message: message,
            data: data
        }
        this.jsonApi.post(path, sendData, () => {
            console.log(type + ' report sent');
        }, () => {
            console.log(type + ' report failed');
        });
    }


}

export default SystemApi;